// import { Col, Container, Row } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import MainButton from '../../UI/main-button/MainButton';
// import classes from './style/ForgetPassword.module.css';
// import { useState } from 'react';
// import { ForgetPassAccount } from './Auth.service';
// import logo from "../../images/Travelicons/2ad783ae6973961a6dc5eb3559ac2054.png";
// import back from "../../images/Travelicons/60fd718ae1253630a08d899141592946.jpeg";

// const ForgetPassword = () => {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState<string>('');
//   const [errorMail, setErrorMail] = useState<string>('');

//   const check = async () => {
//     let y = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
//     setErrorMail('');
//     if (email == '') {
//       setErrorMail('Please enter a valid email');
//     } else if (y.test(email) == false) {
//       setErrorMail('Please enter a valid email');
//     } else {
//       let data = new FormData();
//       data.append('email', email);
//       data.append('lang', 'en');
//       let result = await ForgetPassAccount(data);
//       console.log('result.response', result.response);

//       if (result.response.status) {
//         navigate('/verify?forget_password=1', { state: { email: email, forgetPass: true } });
//       } else {
//         setErrorMail(result.response.msg);
//       }
//     }
//   };

//   return (
//     <div className={classes.BackgroundContainer} style={{ backgroundImage: `url(${back})` }}>
//       <div className={classes.Overlay}></div>
//       <Container className={classes.FormContainer}>
//         <Row className="d-flex justify-content-center align-items-center">
//           <Col xs={12} lg={6}>
//             <div className={classes.FormPadding}>
//               <div className='text-center mb-4'>
//                 <img src={logo} alt="img" width={150} />
//               </div>
//               <h3 className={`text-center fontWeight-bold ${classes.HeaderTitle}`}>
//                 Forget Password
//               </h3>
//               <p className={`text-center ${classes.HeaderPargraph}`}>
//                 Enter Your Email Address To Confirm
//               </p>

//               <div className="mt-3 mb-3 position-relative">
//                 <img src="/icons/carbon_email.svg" alt="img" width={25} className={classes.InputIcon} />
//                 <input
//                   placeholder='e.g, yassinmustafa@email.com'
//                   type="text"
//                   className={`form-control ${classes.Input}`}
//                   required
//                   onChange={e => setEmail(e.target.value)}
//                 />
//                 <div className={classes.error}>{errorMail}</div>
//               </div>

//               <div className="mt-4 mb-2">
//                 <MainButton text="Confirm" onClick={check} />
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default ForgetPassword;

import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import MainButton from '../../UI/main-button/MainButton';
import classes from './style/ForgetPassword.module.css';
import { useState } from 'react';
import { ForgetPassAccount } from './Auth.service';
import logo from "../../images/Travelicons/2ad783ae6973961a6dc5eb3559ac2054.png";
import back from "../../images/Travelicons/60fd718ae1253630a08d899141592946.jpeg";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [errorMail, setErrorMail] = useState<string>('');

  const check = async () => {
    let y = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    setErrorMail('');
    if (email == '') {
      setErrorMail('Please enter a valid email');
    } else if (y.test(email) == false) {
      setErrorMail('Please enter a valid email');
    } else {
      let data = new FormData();
      data.append('email', email);
      data.append('lang', 'en');
      let result = await ForgetPassAccount(data);
      console.log('result.response', result.response);

      if (result.response.status) {
        navigate('/verify?forget_password=1', { state: { email: email, forgetPass: true } });
      } else {
        setErrorMail(result.response.msg);
      }
    }
  };

  return (
    <div className={classes.BackgroundContainer} style={{ backgroundImage: `url(${back})` }}>
      <div className={classes.Overlay}></div>
      <Container className={classes.FormContainer}>
        <Row className="d-flex justify-content-center align-items-center">
          <Col xs={12} lg={6}>
            <div className={classes.FormPadding}>
              <div className='text-center mb-4'>
                <img src={logo} alt="img" width={150} />
              </div>
              <h3 className={`text-center fontWeight-bold ${classes.HeaderTitle}`}>
                Forget Password
              </h3>
              <p className={`text-center ${classes.HeaderPargraph}`}>
                Enter Your Email Address To Confirm
              </p>

              <div className="mt-3 mb-3 position-relative">
                {!errorMail && ( // Only show the icon if there is no error
                  <img src="/icons/carbon_email.svg" alt="img" width={25} className={classes.InputIcon} />
                )}
                <input
                  placeholder='e.g, yassinmustafa@email.com'
                  type="text"
                  className={`form-control ${classes.Input}`}
                  required
                  onChange={e => setEmail(e.target.value)}
                />
                {errorMail && <div className={classes.error}>{errorMail}</div>}
              </div>

              <div className="mt-4 mb-2">
                <MainButton text="Confirm" onClick={check} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgetPassword;